if (!customElements.get('gift-card-postal-option')) {
  customElements.define(
    'gift-card-postal-option',
    class GiftCardPostalOption extends HTMLElement {
      constructor() {
        super();
        this.onSubmit = this.onSubmit.bind(this);
        this.skipNext = false;
      }

      connectedCallback() {
        this.productForm = this.closest('product-form');
        this.checkbox = this.querySelector('input[type="checkbox"]');
        if (!this.productForm || !this.checkbox) return;
        // Capture phase: runs before the theme's own submit handler on the form.
        this.productForm.addEventListener('submit', this.onSubmit, true);
      }

      disconnectedCallback() {
        if (this.productForm) this.productForm.removeEventListener('submit', this.onSubmit, true);
      }

      async onSubmit(event) {
        if (this.skipNext) {
          this.skipNext = false;
          return;
        }
        if (!this.checkbox.checked) return;

        // Add the paper card first, then let the normal "add gift card" request run.
        event.preventDefault();
        event.stopImmediatePropagation();

        const form = event.target.closest('form') || this.productForm.querySelector('form');
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        try {
          await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity }] }),
          });
        } catch (error) {
          console.error('Could not add the postal delivery item', error);
        }

        this.skipNext = true;
        form.requestSubmit();
      }
    }
  );
}
